import './AllInOne.css';
// icons
import SparklesIcon from '../../../assets/icons/sparkles.svg';
import ChatIcon from '../../../assets/icons/chat-bubble-left-right.svg';
import ClipBoardIcon from '../../../assets/icons/clipboard-document-list.svg';
import CubeIcon from '../../../assets/icons/cube-transparent.svg';
import DocumentIcon from '../../../assets/icons/document-chart-bar.svg';
import MagnifyingIcon from '../../../assets/icons/magnifying-glass.svg';
import MapIcon from '../../../assets/icons/map.svg';
import SquaresIcon from '../../../assets/icons/squares-2x2.svg';
import UserIcon from '../../../assets/icons/users.svg';
import {Link} from "react-router-dom";


export default function AllInOne() {


    return (
        <div>
            <section className='all-in-one'>
                <div className='all-in-one-container'>
                    <div className='all-in-one-header'>
                        <div style={{
                            width: '28px',
                            height: '28px',
                            padding: '4px',
                            background: '#0F172A',
                            borderRadius: 9.70,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 12,
                            display: 'inline-flex',
                            marginRight: '16px'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                position: 'relative'
                            }}>
                                <img src={SparklesIcon} width={'24px'}/>
                            </div>
                        </div>
                        <div style={{
                            height: '36px',
                            paddingLeft: 32,
                            paddingRight: 32,
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 36,
                            overflow: 'hidden',
                            border: '1px #0F172A solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            display: 'inline-flex'
                        }}>
                            <div style={{
                                color: '#0F172A',
                                fontSize: 16,
                                fontWeight: '600',
                                wordWrap: 'break-word'
                            }}>All in one
                            </div>
                        </div>
                    </div>
                    <div className='all-in-one-content'>
                        <div className='divider-bar'>
                        </div>
                        <div className='all-in-one-box'>
                            <h6 className="section-title">
                                Your complete AI customer feedback platform
                            </h6>
                            <h6 className="section-subtitle">
                                Automatically collect, analyze and take action on customer feedback with AI-powered
                                solutions.
                            </h6>
                            <div className="all-in-one-cards-container">
                                <div className="all-in-one-card">
                                    <a href="#collect">
                                        <h1 style={{
                                            color: '#2563EB',
                                        }}>Collection
                                        </h1>
                                    </a>
                                    <p>
                                        Use the power of AI surveys, forms and SDK to collect high quality customer
                                        feedback. Connect all your existing feedback sources in one place, with ease.
                                    </p>
                                    <div className="all-in-one-card-list">
                                        <ul>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={SquaresIcon} width={'32px'}/>
                                                </div>
                                                <a href="#3rd-party">
                                                    <p>
                                                        3rd-party integrations
                                                    </p>
                                                </a>
                                            </li>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={ChatIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-survey">
                                                    <p>
                                                        Magic Survey
                                                    </p>
                                                </a>
                                            </li>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={ClipBoardIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-form">
                                                    <p>
                                                        Magic Forms
                                                    </p>
                                                </a>
                                            </li>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={CubeIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-sdk">
                                                    <p>
                                                        Magic SDK
                                                    </p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="all-in-one-card">
                                    <a href="#analysis">
                                        <h1 style={{
                                            color: '#0891B2',
                                        }}>Analysis
                                        </h1>
                                    </a>
                                    <p>
                                        Automatically analyze all your customer feedback and reviews with AI. Discover
                                        AI identified themes and pain points. Save hours manually tagging and
                                        categorizing - experience the power of AI analysis.
                                    </p>
                                    <div className="all-in-one-card-list">
                                        <ul>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={DocumentIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-feedback">
                                                    <p>
                                                        Magic Feedback
                                                    </p>
                                                </a>
                                            </li>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={UserIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-profiles">
                                                    <p>
                                                        Magic Profiles
                                                    </p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="all-in-one-card">
                                    <a href="#action">
                                        <h1 style={{
                                            color: '#16A34A',
                                        }}>Action
                                        </h1>
                                    </a>
                                    <p>
                                        Boost innovation in your teams through our platform and accelerate the pace of
                                        product development. Easily connect insights directly to features to help give
                                        your team context.
                                    </p>
                                    <div className="all-in-one-card-list">
                                        <ul>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={MagnifyingIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-search">
                                                    <p>
                                                        Magic Search
                                                    </p>
                                                </a>
                                            </li>
                                            <li>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    position: 'relative'
                                                }}>
                                                    <img src={MapIcon} width={'32px'}/>
                                                </div>
                                                <a href="#magic-roadmap">
                                                    <p>
                                                        Magic Roadmap
                                                    </p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
